import { useState, useRef, useEffect } from 'react';

const tabs = ['Todos', 'Yoga', 'Meditação', 'Massagem', 'Nutrição'];

const schedule = [
  { day: 'Segunda', time: '07:00', name: 'Yoga Matinal', instructor: 'Ana Costa', type: 'Yoga', duration: '60 min', spots: 8 },
  { day: 'Segunda', time: '10:00', name: 'Meditação Guiada', instructor: 'Rui Santos', type: 'Meditação', duration: '45 min', spots: 12 },
  { day: 'Segunda', time: '19:00', name: 'Yoga Flow', instructor: 'Maria Luz', type: 'Yoga', duration: '75 min', spots: 5 },
  { day: 'Terça', time: '08:00', name: 'Yoga para Iniciantes', instructor: 'Ana Costa', type: 'Yoga', duration: '60 min', spots: 10 },
  { day: 'Terça', time: '18:30', name: 'Nutrição Holística', instructor: 'Pedro Alves', type: 'Nutrição', duration: '90 min', spots: 6 },
  { day: 'Quarta', time: '07:00', name: 'Yoga Dinâmico', instructor: 'Maria Luz', type: 'Yoga', duration: '60 min', spots: 8 },
  { day: 'Quarta', time: '11:00', name: 'Meditação Mindfulness', instructor: 'Rui Santos', type: 'Meditação', duration: '60 min', spots: 15 },
  { day: 'Quarta', time: '17:00', name: 'Massagem Terapêutica', instructor: 'Sofia Melo', type: 'Massagem', duration: '90 min', spots: 3 },
  { day: 'Quinta', time: '09:00', name: 'Hatha Yoga', instructor: 'Ana Costa', type: 'Yoga', duration: '75 min', spots: 9 },
  { day: 'Quinta', time: '19:30', name: 'Yoga Restaurativo', instructor: 'Maria Luz', type: 'Yoga', duration: '90 min', spots: 7 },
  { day: 'Sexta', time: '07:00', name: 'Vinyasa Flow', instructor: 'Maria Luz', type: 'Yoga', duration: '60 min', spots: 6 },
  { day: 'Sexta', time: '10:00', name: 'Respiração & Meditação', instructor: 'Rui Santos', type: 'Meditação', duration: '45 min', spots: 14 },
  { day: 'Sexta', time: '18:00', name: 'Massagem Desportiva', instructor: 'Sofia Melo', type: 'Massagem', duration: '60 min', spots: 4 },
  { day: 'Sábado', time: '09:00', name: 'Yoga Weekend Flow', instructor: 'Ana Costa', type: 'Yoga', duration: '90 min', spots: 12 },
  { day: 'Sábado', time: '11:00', name: 'Meditação em Grupo', instructor: 'Rui Santos', type: 'Meditação', duration: '60 min', spots: 20 },
  { day: 'Domingo', time: '10:00', name: 'Yin Yoga', instructor: 'Maria Luz', type: 'Yoga', duration: '90 min', spots: 8 },
  { day: 'Domingo', time: '16:00', name: 'Nutrição & Bem-estar', instructor: 'Pedro Alves', type: 'Nutrição', duration: '90 min', spots: 8 },
];

const typeColors = {
  Yoga: 'bg-sage/10 text-sage-dark',
  Meditação: 'bg-nude/30 text-ink',
  Massagem: 'bg-beige/40 text-ink',
  Nutrição: 'bg-beige-light text-ink',
};

export default function Schedule() {
  const [active, setActive] = useState(0);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const tabRefs = useRef([]);

  useEffect(() => {
    const el = tabRefs.current[active];
    if (el) {
      setIndicatorStyle({ left: el.offsetLeft, width: el.offsetWidth });
    }
  }, [active]);

  const filtered = active === 0 ? schedule : schedule.filter((c) => c.type === tabs[active]);
  const days = [...new Set(filtered.map((c) => c.day))];

  return (
    <section id="horarios" className="py-28 bg-beige-light/30">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16 reveal">
          <p className="font-dm text-xs tracking-[0.4em] text-sage uppercase mb-4">Planeia a tua semana</p>
          <h2 className="font-playfair italic text-5xl font-light text-ink">Horários de Aulas</h2>
          <div className="w-12 h-px bg-sage mx-auto mt-6" />
        </div>

        {/* Tabs */}
        <div className="reveal mb-10">
          <div className="relative inline-flex bg-white/70 rounded-full p-1 border border-beige/40">
            <div
              className="tab-indicator absolute top-1 bottom-1 bg-sage rounded-full shadow-sm"
              style={{ left: indicatorStyle.left, width: indicatorStyle.width }}
            />
            {tabs.map((tab, i) => (
              <button
                key={tab}
                ref={(el) => (tabRefs.current[i] = el)}
                onClick={() => setActive(i)}
                className={`relative z-10 px-5 py-2 font-dm text-sm rounded-full transition-colors duration-300 cursor-pointer ${
                  active === i ? 'text-white' : 'text-ink-light hover:text-ink'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Table */}
        <div className="reveal overflow-x-auto rounded-2xl border border-beige/40 bg-white/60 shadow-sm">
          <table className="w-full min-w-[640px]">
            <thead>
              <tr className="border-b border-beige/40">
                <th className="font-dm text-xs tracking-widest text-ink-light uppercase text-left px-6 py-4">Dia</th>
                <th className="font-dm text-xs tracking-widest text-ink-light uppercase text-left px-4 py-4">Hora</th>
                <th className="font-dm text-xs tracking-widest text-ink-light uppercase text-left px-4 py-4">Aula</th>
                <th className="font-dm text-xs tracking-widest text-ink-light uppercase text-left px-4 py-4">Instrutor</th>
                <th className="font-dm text-xs tracking-widest text-ink-light uppercase text-left px-4 py-4">Duração</th>
                <th className="font-dm text-xs tracking-widest text-ink-light uppercase text-left px-4 py-4">Vagas</th>
                <th className="px-6 py-4" />
              </tr>
            </thead>
            <tbody>
              {days.map((day) =>
                filtered
                  .filter((c) => c.day === day)
                  .map((c, i) => (
                    <tr
                      key={`${c.day}-${c.time}`}
                      className="border-b border-beige/20 hover:bg-beige-light/30 transition-colors duration-200"
                    >
                      {i === 0 && (
                        <td
                          rowSpan={filtered.filter((x) => x.day === day).length}
                          className="font-playfair text-sm font-medium text-ink px-6 py-4 align-top pt-5 border-r border-beige/20"
                        >
                          {day}
                        </td>
                      )}
                      <td className="font-dm text-sm text-ink-light px-4 py-4 tabular-nums">{c.time}</td>
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-2">
                          <span className="font-dm text-sm text-ink font-medium">{c.name}</span>
                          <span className={`font-dm text-[10px] px-2 py-0.5 rounded-full ${typeColors[c.type]}`}>{c.type}</span>
                        </div>
                      </td>
                      <td className="font-dm text-sm text-ink-light px-4 py-4">{c.instructor}</td>
                      <td className="font-dm text-sm text-ink-light px-4 py-4">{c.duration}</td>
                      <td className="px-4 py-4">
                        <span className={`font-dm text-xs ${c.spots <= 4 ? 'text-nude' : 'text-sage'}`}>
                          {c.spots} vagas
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <button className="font-dm text-xs text-sage border border-sage/30 px-3 py-1.5 rounded-full hover:bg-sage hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                          Inscrever
                        </button>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
